<template>
  <v-card>
    <v-card-title class="text-h5">
      2. osakeryhmän tiedot
    </v-card-title>
    <v-card-text>
      <v-select
        v-model="additionalSharesModify.assetType"
        :items="assetTypes"
        hide-details
        label="Kohdetyyppi"
        class="mt-4"
        outlined
      />

      <v-select
        v-model="additionalSharesModify.transferType"
        :items="transferTypes"
        hide-details
        label="Luovutuksen tyyppi"
        class="mt-4"
        outlined
      />

      <v-text-field
        v-model="additionalSharesModify.residentialID"
        label="Huoneisto- tai muu tunnus"
        outlined
        :rules="textFieldRules"
        class="mt-4"
        hide-details
      />

      <v-text-field
        v-model="additionalSharesModify.area"
        label="Pinta-ala m²"
        outlined
        class="mt-4"
        :rules="textFieldRules"
        hide-details
        type="number"
      />

      <v-text-field
        v-model="additionalSharesModify.shareSellingPrice"
        label="2. osakeryhmän arvo velattomasta kauppahinnasta"
        outlined
        class="mt-4"
        :rules="textFieldRules"
        hide-details
        append-icon="euro_symbol"
        type="number"
      />

      <v-text-field
        v-model="additionalSharesModify.buyerShareLoan"
        label="2. osakeryhmään kohdistuva yhtiölainaosuus"
        outlined
        class="mt-4 mb-2"
        :rules="textFieldRules"
        hide-details
        append-icon="euro_symbol"
        type="number"
      />
      <span v-if="formInValid" class="red--text">
        Täytä vaaditut kentät.<br>
      </span>
      <span v-if="invalidAmounts" class="red--text">
        Määritä 2. osakeryhmän arvo<br>
      </span>
      <span v-if="!formInValid && !invalidAmounts && !buyerShareLoanValid" class="red--text">
        Yhtiölainaosuuden arvo ei voi olla suurempi
        kuin 2. osakeryhmän arvo velattomasta kauppahinnasta.
      </span>
      <v-checkbox
        v-model="additionalSharesModify.firstTimeBuyer"
        dense
        hide-details
        label="Varainsiirtoverovapaus soveltuu"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        color="primary"
        text
        @click="closeDialog()"
      >
        Peruuta
      </v-btn>
      <v-btn
        color="primary"
        text
        :disabled="formInValid || !buyerShareLoanValid || invalidAmounts"
        :loading="sending"
        @click="saveTaxTransferDetails()"
      >
        Tallenna
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'ModifyAdditionalShares',
  props: {
    additionalShares: {
      type: Object,
      default: () => {},
    },
    assetTypes: {
      type: Array,
      default: () => [],
    },
    transferTypes: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    sending: false,
    additionalSharesModify: {},
    textFieldRules: [
      v => v !== '' || 'Pakollinen kenttä',
    ],
  }),
  computed: {
    formInValid() {
      const keys = Object.keys(this.additionalSharesModify);
      return keys.some(k => this.additionalSharesModify[k] === null || this.additionalSharesModify[k] === '');
    },
    buyerShareLoanValid() {
      return +this.additionalSharesModify.buyerShareLoan
        <= +this.additionalSharesModify.shareSellingPrice;
    },
    invalidAmounts() {
      return !(+this.additionalSharesModify.buyerShareLoan > 0)
        && !(+this.additionalSharesModify.shareSellingPrice > 0);
    },
  },
  mounted() {
    this.additionalSharesModify = { ...this.additionalShares };
  },
  methods: {
    ...mapActions({
      modifyAdditionalShares: 'modifyAdditionalShares',
    }),
    closeDialog() {
      this.$bus.$emit('closeAdditionalShareDialog');
    },
    async saveTaxTransferDetails() {
      this.sending = true;
      await this.modifyAdditionalShares({
        id: this.$route.params.propertyId,
        details: this.additionalSharesModify,
      });
      this.sending = false;
      this.$bus.$emit('closeAdditionalShareDialog');
      this.$bus.$emit('reload');
    },
  },
};
</script>
